import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_tenant_stock_age_analysis_brand_analysis_data: { message: "idle" },
};

export const retrieve_tenant_stock_age_analysis_brand_analysis_data_Slice = createSlice({
 name: "retrieve_tenant_stock_age_analysis_brand_analysis_data",
 initialState,
 reducers: {
  success_retrieve_tenant_stock_age_analysis_brand_analysis_data: (state, action) => {
   state.retrieve_tenant_stock_age_analysis_brand_analysis_data = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_tenant_stock_age_analysis_brand_analysis_data: (state, action) => {
   state.retrieve_tenant_stock_age_analysis_brand_analysis_data = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_tenant_stock_age_analysis_brand_analysis_data: (state) => {
   state.retrieve_tenant_stock_age_analysis_brand_analysis_data = { status: app_consts.IDLE };
  },
  loading_retrieve_tenant_stock_age_analysis_brand_analysis_data: (state) => {
   state.retrieve_tenant_stock_age_analysis_brand_analysis_data = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_tenant_stock_age_analysis_brand_analysis_data, fail_retrieve_tenant_stock_age_analysis_brand_analysis_data, reset_retrieve_tenant_stock_age_analysis_brand_analysis_data, loading_retrieve_tenant_stock_age_analysis_brand_analysis_data } = retrieve_tenant_stock_age_analysis_brand_analysis_data_Slice.actions;

export default retrieve_tenant_stock_age_analysis_brand_analysis_data_Slice.reducer;